
export const otherPaths = {
  '/orders': {
    get: {
      summary: 'List all orders',
      operationId: 'listOrders',
      parameters: [
        {
          name: 'status',
          in: 'query',
          schema: {
            type: 'string',
            enum: ['pending', 'processing', 'completed', 'cancelled'],
          },
          description: 'Filter orders by status',
        },
        {
          name: 'customer_id',
          in: 'query',
          schema: {
            type: 'integer',
          },
          description: 'Filter orders by customer ID',
        },
        {
          name: 'limit',
          in: 'query',
          schema: {
            type: 'integer',
            default: 100,
          },
          description: 'Number of items to return',
        },
        {
          name: 'offset',
          in: 'query',
          schema: {
            type: 'integer',
            default: 0,
          },
          description: 'Number of items to skip',
        },
      ],
      responses: {
        '200': {
          description: 'A list of orders',
          content: {
            'application/json': {
              schema: {
                type: 'array',
                items: {
                  $ref: '#/components/schemas/Order',
                },
              },
            },
          },
        },
      },
    },
    post: {
      summary: 'Create a new order',
      operationId: 'createOrder',
      requestBody: {
        required: true,
        content: {
          'application/json': {
            schema: {
              $ref: '#/components/schemas/Order',
            },
          },
        },
      },
      responses: {
        '201': {
          description: 'The created order',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/Order',
              },
            },
          },
        },
      },
    },
  },
  '/properties': {
    get: {
      summary: 'List all properties',
      operationId: 'listProperties',
      parameters: [
        {
          name: 'search',
          in: 'query',
          schema: {
            type: 'string',
          },
          description: 'Search term to filter properties by address, city, or state',
        },
        {
          name: 'association_id',
          in: 'query',
          schema: {
            type: 'integer',
          },
          description: 'Filter properties by association ID',
        },
        {
          name: 'limit',
          in: 'query',
          schema: {
            type: 'integer',
            default: 100,
          },
          description: 'Number of items to return',
        },
        {
          name: 'offset',
          in: 'query',
          schema: {
            type: 'integer',
            default: 0,
          },
          description: 'Number of items to skip',
        },
      ],
      responses: {
        '200': {
          description: 'A list of properties',
          content: {
            'application/json': {
              schema: {
                type: 'array',
                items: {
                  $ref: '#/components/schemas/Property',
                },
              },
            },
          },
        },
      },
    },
    post: {
      summary: 'Create a new property',
      operationId: 'createProperty',
      requestBody: {
        required: true,
        content: {
          'application/json': {
            schema: {
              $ref: '#/components/schemas/Property',
            },
          },
        },
      },
      responses: {
        '201': {
          description: 'The created property',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/Property',
              },
            },
          },
        },
      },
    },
  },
  '/properties/{id}': {
    get: {
      summary: 'Get a property by ID',
      operationId: 'getProperty',
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: {
            type: 'integer',
          },
        },
      ],
      responses: {
        '200': {
          description: 'The requested property',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/Property',
              },
            },
          },
        },
      },
    },
    put: {
      summary: 'Update a property',
      operationId: 'updateProperty',
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: {
            type: 'integer',
          },
        },
      ],
      requestBody: {
        required: true,
        content: {
          'application/json': {
            schema: {
              $ref: '#/components/schemas/Property',
            },
          },
        },
      },
      responses: {
        '200': {
          description: 'The updated property',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/Property',
              },
            },
          },
        },
      },
    },
    delete: {
      summary: 'Delete a property',
      operationId: 'deleteProperty',
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: {
            type: 'integer',
          },
        },
      ],
      responses: {
        '204': {
          description: 'Property deleted successfully',
        },
      },
    },
  },
  '/properties/autocomplete': {
    get: {
      summary: 'Search properties by address or association name for autocomplete',
      operationId: 'autocompleteProperties',
      parameters: [
        {
          name: 'term',
          in: 'query',
          required: true,
          schema: {
            type: 'string',
          },
          description: 'Search term to find matching properties by address or association name (min 2 characters)',
        },
        {
          name: 'limit',
          in: 'query',
          schema: {
            type: 'integer',
            default: 10,
          },
          description: 'Maximum number of results to return',
        },
      ],
      responses: {
        '200': {
          description: 'List of properties matching the search term',
          content: {
            'application/json': {
              schema: {
                type: 'array',
                items: {
                  type: 'object',
                  properties: {
                    id: { type: 'integer' },
                    value: { type: 'integer' },
                    label: { type: 'string' },
                    address: { type: 'string' },
                    suite_unit: { type: 'string', nullable: true },
                    city: { type: 'string', nullable: true },
                    state: { type: 'string', nullable: true },
                    zip_code: { type: 'string', nullable: true },
                    association_id: { type: 'integer' },
                    association_name: { type: 'string', nullable: true },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
};
